// pragmaSolidity.json
const PRAGMA_SOLIDITY = {
  title: "Fundamentos Iniciales de Solidity",
  sections: [
    {
      id: "hero",
      heading: "Fundamentos Iniciales de Solidity",
      text: `Usaremos Remix IDE para escribir, compilar, desplegar y depurar contratos directamente en el navegador.
Además, tendrás a mano la documentación oficial de Solidity v0.8.13 para profundizar en referencias y buenas prácticas.`,
      links: [
        { label: "Abrir Remix IDE ↗", url: "https://remix.ethereum.org" },
        { label: "Documentación Solidity v0.8.13", url: "https://docs.soliditylang.org/en/v0.8.13/index.html" }
      ],
      note: `Remix ofrece editor, compilador, desplegador y herramientas de análisis. 
La documentación oficial describe tipado estático, herencia, librerías y tipos definidos por el usuario. 
Procura alinear tu pragma con el compilador seleccionado en Remix.`
    },
    {
      id: "version-pragma",
      heading: "1. La Versión del Compilador",
      text: `Indica siempre la versión con pragma solidity. 
Si no coincide con el compilador elegido, la compilación fallará. 
También se pueden usar rangos de versiones.`,
      code: `// Compatible con 0.8.4 y superiores < 0.9
pragma solidity ^0.8.4;

// También válido con rangos
pragma solidity >=0.6.0 <0.9.0;`
    },
    {
      id: "natspec",
      heading: "2. Comentarios y NatSpec",
      text: `Documentar facilita la colaboración y evita reescrituras. 
En producción, usa NatSpec para describir contratos y funciones con etiquetas como @title, @notice, @dev, @param y @return.`,
      code: `// Una sola línea

/*
  Varias líneas: explica supuestos y limitaciones.
*/

/// @title Ejemplo de documentación con NatSpec
/// @notice Breve descripción de la función
/// @dev Detalles para desarrolladores
/// @param amount Monto a transferir
/// @return ok true si la operación fue exitosa`
    },
    {
      id: "import",
      heading: "3. Importación de Contratos y Librerías",
      text: `Reutiliza código probado con import. OpenZeppelin ofrece implementaciones seguras de ERC-20/721/1155.`,
      code: `// Ejemplo (paquete vía npm o usando Remix con GitHub/Skypack)
import "@openzeppelin/contracts/token/ERC20/ERC20.sol";`
    },
    {
      id: "declaracion-contrato",
      heading: "4. Declaración de un Contrato",
      text: `Declara tu contrato con la palabra reservada contract. 
Dentro defines variables, funciones, eventos y estructuras.`,
      code: `pragma solidity ^0.8.4;

contract TokenExample {
  // Variables, eventos y funciones
}`
    },
    {
      id: "constructor",
      heading: "5. El Constructor",
      text: `Se ejecuta una única vez al desplegar el contrato. 
Es útil para inicializar parámetros como nombre, símbolo o propietario.`,
      code: `pragma solidity ^0.8.4;

contract TokenExample {
  string public name;
  string public symbol;

  constructor(string memory _name, string memory _symbol) {
    name = _name;
    symbol = _symbol;
  }
}`
    },
    {
      id: "herencia",
      heading: "6. Herencia",
      text: `Solidity soporta herencia para reutilizar lógica probada, 
por ejemplo usando contratos de OpenZeppelin.`,
      code: `pragma solidity ^0.8.4;

import "@openzeppelin/contracts/token/ERC721/ERC721.sol";

contract MyNFT is ERC721 {
  constructor() ERC721("MyNFT", "MNFT") {}
}`
    },
    {
      id: "cierre",
      heading: "7. Resumen Final",
      text: `Con estos fundamentos podrás avanzar hacia pruebas, eventos, modifiers, manejo de errores, patrones de actualización y seguridad. 
Mantén tu pragma alineado con el compilador de Remix y consulta la documentación oficial cuando surjan dudas de sintaxis o comportamiento.`
    }
  ]
};

export default PRAGMA_SOLIDITY;
